module.exports = __webpack_public_path__ + "static/slidecard02_01-6be8fcaba9d00632bece834cfce9de9c.png";